export default "__VITE_ASSET__GCw4Ma7C__"